import Unlit from '@/glxp/shaders/unlit.glsl'
import Post from '@/glxp/shaders/post.glsl'
import Sprite from '@/glxp/shaders/sprite.glsl'
import Hands from '@/glxp/shaders/hand.glsl'

export default {
  'unlit': Unlit,
  'post': Post,
  'sprite': Sprite,
  'hand': Hands,
}
